(function () {
    if (window.__calculateSavingsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.calculateSavings = window.Branch.calculateSavings || {};
    window.Branch.calculateSavings.sliders = window.Branch.calculateSavings.sliders || {};
    window.__calculateSavingsHasFired = true;

function updateLabelPosition(rangeSlider, valPercent) {
  const label = rangeSlider.closest('.shopify-section').querySelector('.calculate-savings__dot-label');
  if (!label) return;

  const sliderWidth = rangeSlider.offsetWidth;

  const thumbWidth = 24;
  const labelWidth = 42;
  const trackWidth = sliderWidth - thumbWidth;
  const position = (valPercent / 100) * trackWidth;
  const thumbCenter = position + (thumbWidth / 2);
  const labelLeft = thumbCenter - (labelWidth / 2);

  label.style.left = `${labelLeft}px`;
}

function handleRangeSliderUpdate(rangeSlider, dotColor, progressColor, bgColor, minValue, maxValue, defaultValue) {
    const sliderValue = rangeSlider.closest('.shopify-section').querySelector(".calculate-savings__dot-label");
    if (!sliderValue) return;

    const min = parseFloat(rangeSlider.min);
    const max = parseFloat(rangeSlider.max);
    const value = parseFloat(rangeSlider.value);

    const valPercent = ((value - min) / (max - min)) * 100;

    rangeSlider.style.background = `linear-gradient(to right, ${progressColor} ${valPercent}%, ${bgColor} ${valPercent}%)`;

    let savings = rangeSlider.value * 1963 + (Math.ceil(rangeSlider.value / 10) * 3692);

    sliderValue.textContent = parseInt(rangeSlider.value) >= maxValue ? `${rangeSlider.value}+` : rangeSlider.value;
    updateLabelPosition(rangeSlider, valPercent);
    const savingsElement = rangeSlider.closest('.shopify-section').querySelector(".calculate-savings__savings-summary-amount");
    savingsElement.textContent = `$${savings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

function initRangeSlider(calculateSavingsSection, parent) {
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    let rangeSlider = parent.querySelector("#calculate-savings__slider");
    rangeSlider.parentElement.setAttribute('data-is-safari', isSafari);
    if (!rangeSlider) return;

    let dotColor = parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-slider-bar-dot-color');
    let progressColor = parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-slider-bar-progress-color');
    let bgColor = parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-slider-bar-bg-color');
    let minValue = parseInt(parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-min-value'));
    let maxValue = parseInt(parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-max-value'));
    let defaultValue = parseInt(parent.querySelector('.calculate-savings__range-slider-container').getAttribute('data-default-value'));
    let resizeTimeout;

    handleRangeSliderUpdate(rangeSlider, dotColor, progressColor, bgColor, minValue, maxValue, defaultValue);


    rangeSlider.addEventListener('input', () => {
        handleRangeSliderUpdate(rangeSlider, dotColor, progressColor, bgColor, minValue, maxValue, defaultValue);
    }, { passive: true }); 

    rangeSlider.style.touchAction = 'manipulation';


    window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        handleRangeSliderUpdate(rangeSlider, dotColor, progressColor, bgColor, minValue, maxValue, defaultValue);
    }, 200);
    });
}

function actionsOnVisible(calculateSavingsSection, parent){
    calculateSavingsSection.setAttribute('data-interacted', true);
    initRangeSlider(calculateSavingsSection, parent)
}    

function initCalculateSavingsCallback(calculateSavingsSection, parent, type){
        let fromLoad = calculateSavingsSection.closest('.homepage-content-container') && calculateSavingsSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(calculateSavingsSection, parent);
        } else if(!calculateSavingsSection.closest('.homepage-content-container')) {
            actionsOnVisible(calculateSavingsSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = calculateSavingsSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                calculateSavingsSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(calculateSavingsSection, parent);
                calculateSavingsSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.calculateSavings.calculateSavingsInitOnLoad = function(type){
        let calculateSavingsSections = document.querySelectorAll('.calculate-savings:not([data-initialized="true"])');
        calculateSavingsSections.forEach((calculateSavingsSection) => {
            let parent = calculateSavingsSection.closest('.shopify-section');
            calculateSavingsSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initCalculateSavingsCallback(calculateSavingsSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initCalculateSavingsCallback, '.homepage-content-container', calculateSavingsSection, calculateSavingsSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.calculateSavings.calculateSavingsInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.calculateSavings.calculateSavingsInitOnLoad('regular'));
    }
  })();
